import { fetcher } from '../../fetcher';
import { Ip } from './external.types';

export const external = {
  getIp: () =>
    fetcher.get<Ip>(
      `https://api.ipgeolocation.io/ipgeo?apiKey=${process.env.IPGEOLOCATION || 'fa8dde18650f4236b5c450e041c13a5a'}`,
      { lang: 'en' },
    ),
  getCountryCode: async () => {
    try {
      const { data } = await external.getIp();
      return data.country_code2.toLowerCase();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);

      const { data } = await fetcher.get<{ country_code: string }>('https://ipwho.is', { lang: 'en' });
      return data.country_code.toLowerCase();
    }
  },
};
